import generateIcon from './generateIcon';
var Close1 = "<svg fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.377 7.245a.8.8 0 00-1.154 1.11l3.717 3.867-3.717 3.869a.8.8 0 101.154 1.108l3.673-3.822 3.673 3.822a.8.8 0 001.154-1.108l-3.718-3.869 3.718-3.868a.8.8 0 00-1.154-1.109l-3.673 3.823-3.673-3.823z\"/></svg>";
export default generateIcon(Close1, {
  name: 'CloseV1Outlined'
});